import { useEffect } from 'react'
import type { RefObject } from 'react'
import { useUpplasning } from '../lib/upplasning'

/** Lyssna-knappen på kapitelsidan plus minispelaren (fast nere till höger)
 *  som syns medan uppläsningen pågår. Talsyntesen körs helt i webbläsaren
 *  (Web Speech API); i webbläsare utan stöd renderas ingenting.
 *  `nyckel` (kapitel-id) och `aktiv` (Text-fliken vald) stoppar uppläsningen
 *  när kapitlet byts eller texten döljs — markering och medföljning pekar
 *  annars på en text läsaren inte längre ser. */
export default function LyssnaKontroll({
  malRef,
  nyckel,
  aktiv,
}: {
  malRef: RefObject<HTMLElement | null>
  nyckel: string
  aktiv: boolean
}) {
  const { status, stods, hastighet, starta, pausa, fortsatt, stoppa, cyklaHastighet } = useUpplasning(malRef)

  useEffect(() => {
    if (!aktiv) stoppa()
  }, [aktiv, stoppa])
  useEffect(() => () => stoppa(), [nyckel, stoppa])

  if (!stods) return null

  return (
    <>
      <button
        type="button"
        className="knapp knapp-sekundar knapp-liten"
        onClick={status === 'stilla' ? starta : stoppa}
        aria-pressed={status !== 'stilla'}
      >
        {status === 'stilla' ? '🔊 Lyssna' : '🔇 Sluta lyssna'}
      </button>
      {status !== 'stilla' && (
        <div className="lyssna-spelare no-print" role="group" aria-label="Uppläsningskontroller">
          <button type="button" className="knapp knapp-sekundar knapp-liten" onClick={status === 'laser' ? pausa : fortsatt}>
            {status === 'laser' ? '⏸ Pausa' : '▶ Fortsätt'}
          </button>
          <button
            type="button"
            className="knapp knapp-sekundar knapp-liten"
            onClick={cyklaHastighet}
            title="Uppläsningshastighet"
            aria-label={`Uppläsningshastighet ${String(hastighet).replace('.', ',')}×, tryck för att ändra`}
          >
            {String(hastighet).replace('.', ',')}×
          </button>
          <button type="button" className="knapp knapp-sekundar knapp-liten" onClick={stoppa}>
            ⏹ Stoppa
          </button>
        </div>
      )}
    </>
  )
}
